import React from 'react';
import { Avatar } from '@material-ui/core';
import { store } from 'redux/store';
import { push } from 'connected-react-router';
import UserImage from 'components/Image/UserImage';
import DataTable from '../../../components/Table/DataTable';
import CurrencyText from '../../../components/TextHover/CurrencyText';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Profile",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Account Manager",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Gross Profit",
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => <CurrencyText currency="ZAR" value={value} popoverStyle={{ marginTop: -20 }} />,
            sortDirection: 'desc'
        }
    }
];



class AccountManagerTotalsTable extends React.Component {

    options = {
        onRowClick: (row) => store.dispatch(push('/users/view/' + row[0]))
    };

    render() {
        return (
                <DataTable
                    title={"Details"}
                    data={
                        this.props.data
                        .map(stat => 
                            [
                                stat.user.id, 
                                <UserImage {...stat.user} />, 
                                stat.user.name + (stat.user.surname ? " " + stat.user.surname : ""), 
                                stat.total_gp
                            ]
                        )
                    }
                    columns={columns}
                    options={this.options}
                />
        );
    }
}

export default AccountManagerTotalsTable;
